import React from 'react';
import PropTypes from 'prop-types';
import SecondaryNav from '../../components/SecondaryNav';
import Footer from '../../components/Footer';
import style from './style.css';
import NavBar from '../../components/NavBar';

const Fortress = window.cccisd.fortress;

export default class MainLayout extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        showSecondaryNav: PropTypes.bool,
    };

    static defaultProps = {
        className: 'container',
        showSecondaryNav: false,
    };

    render() {
        return (
            <div className={style.wrapper}>
                <NavBar className={this.props.className} />
                <div className={style.body}>
                    {Fortress.auth() && <SecondaryNav className={this.props.className} />}
                    <div className={this.props.className}>{this.props.children}</div>
                </div>

                <div className={style.footer}>
                    <Footer className={this.props.className} />
                </div>
            </div>
        );
    }
}
